import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c884931"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "col-lg-4 col-form-label fw-semobold fs-6" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true"
}
const _hoisted_5 = { class: "w-100 h-100 position-relative" }
const _hoisted_6 = {
  key: 0,
  class: "bi bi-pencil-fill fs-7"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-2" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "col-lg-8"
}
const _hoisted_10 = { class: "text-danger" }

import { computed, nextTick, ref, watch } from "vue";
import clientSvc from "@/projects/client/services/ClientGlobalService";
import tenantSvc from "@/projects/tenant/services/TenantGlobalService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { useI18n } from "vue-i18n";
import { isMobile } from "@/core/config/WindowConfig";
import { FileFormatTypes } from "@/core/types/FileFormatTypes";
import VuePdfEmbed from "vue-pdf-embed";
import store from "@/store";
import { getImageUrlWithToken } from "@/core/plugins/ProcessImageLink";

const BlankImage = "";

export default /*#__PURE__*/_defineComponent({
  __name: 'FileUploader2',
  props: {
    handleFileUpload: {},
    title: {},
    disableDefaultUpload: { type: Boolean, default: false },
    partyId: {},
    previewMedia: {},
    disableDelete: { type: Boolean }
  },
  emits: ["fileUploaded"],
  setup(__props: any, { expose: __expose, emit: emits }) {

const props = __props;

const { t } = useI18n();



const isLoading = ref<boolean>(false);

const fileUploadInputRef = ref<any>();
const handleFileUploadIconClick = () => fileUploadInputRef.value.click();
const showSizeError = ref<boolean>(false);
const contentType = ref<FileFormatTypes>(FileFormatTypes.JPEG);
const previewUrl = ref<string>(BlankImage); // used for preview image
let form = new FormData(); // the form of request body

const fileObj = ref<any>(null);

// emits to give back the guid of uploaded file for parent component



const onChangeFileHandler = async (e: Event) => {
  const target = e.target as HTMLInputElement;
  if (!target.files) return;
  const file = target.files[0];
  const fileSize = file.size; // less than 20MB
  if (fileSize > 20000000) {
    clearPreview();
    showSizeError.value = true;
    return;
  }
  showSizeError.value = false;

  target.value = "";
  contentType.value =
    {
      ["application/pdf"]: FileFormatTypes.PDF,
      ["image/jpeg"]: FileFormatTypes.JPEG,
      ["image/jpg"]: FileFormatTypes.JPG,
      ["image/png"]: FileFormatTypes.PNG,
      ["text/plain"]: FileFormatTypes.TXT,
    }[file.type] ?? FileFormatTypes.JPEG;

  form.delete("file");
  form.append("file", file);
  const reader = new FileReader();
  reader.onload = (e) => {
    previewUrl.value = (e.target as FileReader).result as string;
  };
  reader.readAsDataURL(file);

  if (props.disableDefaultUpload || !props.handleFileUpload) {
    emits("fileUploaded", form);
    return;
  }

  // if uploadFileFunc is a promise
  // console.log("uploadFileFunc", typeof uploadFileFunc);
  try {
    fileObj.value = await props.handleFileUpload(form);

    MsgPrompt.success(t("tip.submitSuccess")).then(() =>
      emits("fileUploaded", fileObj)
    );
  } catch (err) {
    MsgPrompt.error(err);
  }
};

const removeImage = async () => {
  // console.log("remove image initiated", currentGuid.value);
  isLoading.value = true;
  previewUrl.value = BlankImage;
  await nextTick();
  if (!fileObj.value) return;
  form.delete("uploadedFile");

  const roles = store.state.AuthModule?.user?.roles;

  const deleteFileFunc =
    roles && roles.includes("TenantAdmin")
      ? tenantSvc.deleteMediaFileByGuid
      : clientSvc.deleteMediaFileByGuid;
  try {
    console.log(fileObj.value);
    if (fileObj.value.guid) await deleteFileFunc(fileObj.value.guid);
  } catch (err) {
    MsgPrompt.error(err);
  }
  fileObj.value = null;
  isLoading.value = false;
};

// if default upload is disabled and there is an existing preview, disable delete func
// because the deleting func is always undefined
const disableRemoveImageFunc = computed(() => {
  return props.disableDefaultUpload && fileObj.value === null;
});

const imageHasPreview = computed(() => previewUrl.value !== BlankImage);

const clearPreview = () => {
  previewUrl.value = BlankImage;
  form = new FormData();
};

watch(
  () => props.previewMedia,
  () => {
    // console.log("previewMedia", props.previewMedia);

    if (!props.previewMedia) return;
    if (props.previewMedia.guid === fileObj.value?.guid) return;

    previewUrl.value = getImageUrlWithToken(props.previewMedia.guid);
    fileObj.value = props.previewMedia;
  }
);

// onMounted(() => {
//   console.log("previewMedia", props.previewMedia);
//   if (props.previewMedia) {
//     previewUrl.value = getImageUrlWithToken(props.previewMedia.guid);
//     console.log(previewUrl.value);
//   }
// });

__expose({
  clearPreview,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (!isLoading.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["image-input-wrapper overflow-hidden", {
            ' w-350px h-250px': !_unref(isMobile),
            ' w-300px h-200px': _unref(isMobile),
          }]),
              style: _normalizeStyle(
            previewUrl.value !== '' ? `background-image: url(${previewUrl.value})` : ''
          )
            }, [
              (
              [_unref(FileFormatTypes).PDF].includes(contentType.value) && imageHasPreview.value
            )
                ? (_openBlock(), _createBlock(_unref(VuePdfEmbed), {
                    key: 0,
                    source: previewUrl.value,
                    class: "w-100 h-100"
                  }, null, 8, ["source"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                (!imageHasPreview.value)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      onClick: handleFileUploadIconClick,
                      class: "fa-solid fa-folder-plus fa-2xl position-absolute cursor-pointer",
                      style: {"color":"#d7e1ee","font-size":"12rem","top":"50%","left":"50%","transform":"translate(-50%, -50%)"}
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("label", {
                class: _normalizeClass({
              'btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow':
                imageHasPreview.value,
            }),
                "data-kt-image-input-action": "change",
                "data-bs-toggle": "tooltip",
                title: "Upload File"
              }, [
                (imageHasPreview.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                  : _createCommentVNode("", true),
                _createElementVNode("input", {
                  ref_key: "fileUploadInputRef",
                  ref: fileUploadInputRef,
                  type: "file",
                  name: "file",
                  accept: ".png, .jpg, .jpeg, .pdf, .heic",
                  onChange: onChangeFileHandler
                }, null, 544)
              ], 2)
            ], 6))
          : _createCommentVNode("", true),
        (imageHasPreview.value && !props.disableDelete)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow",
              "data-kt-image-input-action": "remove",
              "data-bs-toggle": "tooltip",
              onClick: removeImage,
              title: "Remove avatar"
            }, _hoisted_8))
          : _createCommentVNode("", true)
      ])
    ]),
    (showSizeError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)("tip.fileSizeLimit")), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})